import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';

interface InterventionFileProjectState {
  id: any;
  pmContractId: any;
  pmContract: any;
  companyId: any;
  company: any;
  workPlaceId: any;
  workPlace: any;
  hours: any;
  minutes: any;
  traveledKilometers: any;
  timeTransportHours: any;
  timeTransportMinutes: any;
  attachedImage: any;
  observations: any;
  interventionFileProjectInstallations: any;
  deliveryDate: any;
  installedDevicesWithQuantity: any;
  // Table props
  props: {
    searchTerm: string;
    searchTermType: string;
    skip: number;
    take: number;
    totalItems: number;
    refresh: number;
  };
  selectedRecords: React.Key[];
}

const currentDate = moment().format('YYYY-MM-DD');

export const initialState: InterventionFileProjectState = {
  id: '',
  pmContractId: '',
  pmContract: null,
  companyId: '',
  company: null,
  workPlaceId: '',
  workPlace: null,
  attachedImage: '',
  observations: '',
  hours: 0,
  minutes: 0,
  traveledKilometers: 0,
  timeTransportMinutes: 0,
  timeTransportHours: 0,
  interventionFileProjectInstallations: [],
  installedDevicesWithQuantity: [],
  deliveryDate: currentDate,
  // Table props
  props: {
    searchTerm: '',
    searchTermType: '',
    skip: 0,
    take: 10,
    totalItems: 0,
    refresh: 0,
  },
  selectedRecords: [],
};

const interventionFileProjectSlice = createSlice({
  name: 'interventionFileProject',
  initialState,
  reducers: {
    setInterventionFileProject: (state, action: PayloadAction<Partial<InterventionFileProjectState>>) => {
      return { ...state, ...action.payload };
    },
    updateField: (state: any, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    updateProps: (state: any, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props[field] = value;
    },
    setSelectedRecords: (state, action: PayloadAction<React.Key[]>) => {
      state.selectedRecords = action.payload;
    },
    clearSelectedRecords: (state) => {
      state.selectedRecords = [];
    },
  },
});

export const { setInterventionFileProject, updateField, updateProps, setSelectedRecords, clearSelectedRecords } =
  interventionFileProjectSlice.actions;

export default interventionFileProjectSlice.reducer;
